import React from 'react';

// --- MAPEO DE REACCIONES PREMIUM (IMÁGENES REALISTAS) ---
export const REACCIONES_MAP = {
  like: { 
    label: 'Me gusta', 
    color: '#1877f2', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/1f44d.png',
    bg: '#e7f3ff' 
  },
  love: { 
    label: 'Me encanta', 
    color: '#f33e58', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/2764-fe0f.png',
    bg: '#fde9eb' 
  },
  haha: { 
    label: 'Me divierte', 
    color: '#f7b125', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/1f606.png',
    bg: '#fef5e7' 
  },
  wow: { 
    label: 'Me asombra', 
    color: '#f7b125', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/1f62e.png',
    bg: '#fef5e7' 
  },
  sad: { 
    label: 'Me entristece', 
    color: '#f7b125', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/1f622.png',
    bg: '#fef5e7' 
  },
  angry: { 
    label: 'Me enoja', 
    color: '#f02849', 
    img: 'https://cdnjs.cloudflare.com/ajax/libs/emoji-datasource-apple/14.0.0/img/apple/64/1f621.png',
    bg: '#fbe9eb' 
  },
};
